<template>
  <div 
    v-if="value" 
    :id="id"
    class="zone text-align-center" 
    :class="customClasses"
    :style="{ width: `${widthPercentage}%` }"
    ref="timelineZoneEl"> 
    <span class="zone-value-info">
      {{ value }} {{unit}}
    </span>

    <b-tooltip v-if="hasOverflow" :target="id" :title="displayLabel"></b-tooltip>
  </div>
</template>

<script>
export default {
  name: 'TimelineZone',
  props: [
    'customClasses',
    'unit',
    'widthPercentage',
    'value',
    'id'
  ],
  data () {
    return {
      hasOverflow: false
    }
  },
  computed: {
    displayLabel () {
      return `${this.value} ${this.unit}`
    }
  },
  mounted () {
    this.$nextTick(() => {
      const el = this.$refs.timelineZoneEl

      if(el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
        this.hasOverflow = true
      }
    })
  },
}
</script>

<style lang="scss" scoped>
  .zone {
    display: table-cell;
    height: 10px;
    position: relative;
    font-size: 12px;
    color: $wood-smoke;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 0;
  }

 .zone-value-info {
  text-overflow: ellipsis;
  display: inline-block;
  white-space: nowrap;
}
</style>

